import axiosInstance from "@/api/axiosInstance";

export interface ProductReportData {
  sales: {
    totalOrders: number;
    totalRevenue: number;
    averageOrderValue: number;
  };
  topProducts: Array<{
    productId: number;
    productName: string;
    totalQuantity: number;
    totalRevenue: number;
  }>;
  fulfillment: {
    totalItems: number;
    shippedItems: number;
    pendingItems: number;
  };
}

export const fetchProductReport = async (params: { startDate?: string; endDate?: string }) => {
  const response = await axiosInstance.get("/api/private/product-report", { params });
  return response.data;
};
